
window.selectGift = function(e) {
    var $btn = $(e.target);
    var variantId = $btn.data('variant-id');
    $.ajax({
        method: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: variantId,
            properties: {
                _gift: true
            }
        },
        dataType: 'json'
    }).success(function (response) {
        console.log(response);
    }).error(function(error) {
        console.log(JSON.parse(error.responseText));
    }).complete(function() {
        $('#cart-reload-curtain').attr('hidden', false);
        location.reload();
    });
}

var removeGift = function(key) {
    $.post('/cart/update.js', {
        updates: {
            [key]: 0
        }
    }).always(function() {
        $('#cart-reload-curtain').attr('hidden', false);
        location.reload();
    });
}

function free_gift_cart() {
    var $giftSettings = $('script[data-gifts-settings]'), giftSettingsJson, $giftSectionWrapper, $giftSectionTitle,
        $giftSectionProducts, giftItemInCart = null;

    if ($giftSettings.length) {

        $giftSectionWrapper = $('#gifts-section-wrapper');
        $giftSectionTitle = $giftSectionWrapper.find('.gifts-section-title');
        $giftSectionProducts = $giftSectionWrapper.find('.gifts-section-products');

        try {
            giftSettingsJson = JSON.parse($giftSettings.html());
        } catch (error) {
            giftSettingsJson = {};
        }

        $.getJSON("/cart.json", function (cart) {
            //debugger;
            $giftSectionTitle.html("");
            $giftSectionProducts.html("");

            cart.items.forEach(function (item) {
                if (item && item.properties && item.properties._gift) {
                    giftItemInCart = item;
                }
            });

            //console.log(cart.total_price < giftSettingsJson.treshold)
            //console.log(cart.total_price > giftSettingsJson.treshold_shipping)

            if (Object.keys(giftSettingsJson).length) {

                if (!giftItemInCart) {

                    $giftSectionWrapper.attr('hidden', false);

                    if (cart.total_price > giftSettingsJson.treshold) {
                        if (giftSettingsJson.products) {
                            giftSettingsJson.products.forEach(product => {
                                var $template = $(giftSettingsJson.template);
                                $template.find('img').attr('src', product.featured_image);
                                $template.find('p').html(product.title);
                                $template.find('button').attr('data-variant-id', product.variants[0].id);
                                $giftSectionProducts.append($template);
                            });
                        }
                        $giftSectionTitle.html(giftSettingsJson.labels.unleash_gifts_cart);
                    } else {
                        if (cart.total_price > giftSettingsJson.treshold_shipping) {
                            $giftSectionTitle.html(giftSettingsJson.labels.unleash_gifts_and_shipping_achieved);
                        } else {
                            $giftSectionTitle.html(giftSettingsJson.labels.unleash_gifts_and_shipping);
                        }
                    }

                } else {

                    if (cart.total_price < giftSettingsJson.treshold) {

                        if (giftItemInCart) {
                            removeGift(giftItemInCart.key);
                        }

                    }

                }

            }

        });

        window.giftItemInCart = giftItemInCart;
        window.tresholdGift = giftSettingsJson && giftSettingsJson.treshold ? giftSettingsJson.treshold : null;
        window.tresholdShipping = giftSettingsJson && giftSettingsJson.treshold_shipping ? giftSettingsJson.treshold_shipping : null;

    }
}


document.addEventListener("DOMContentLoaded", free_gift_cart);

document.addEventListener("cart:updated", function() {
    setTimeout(free_gift_cart, 500);
});

document.addEventListener("ajaxProduct:added", function() {
    setTimeout(free_gift_cart, 500);
});

document.addEventListener("CartDrawer:open", function() {
    setTimeout(free_gift_cart, 500);
});
